/**
 * ข้อความที่อยู่ ↔ ที่อยู่แยกช่อง ฝั่ง OrderCus
 * ฟอร์มยังเก็บที่อยู่เป็นข้อความเต็ม (form.address) เหมือนเดิม — ช่องแยกประกอบเป็นข้อความรูปแบบมาตรฐาน
 * ตอนบันทึกแปลงข้อความกลับเป็นช่องแยกด้วย addressPartsOfText (ตรงทุกตัวอักษรเท่านั้น)
 */
import {
  composeAddress,
  isAddressPartsComplete,
  loadedThaiAddressDb,
  parseThaiAddress,
  type AddressParts,
} from './thaiAddress'

export const THAI_ADDRESS_URL = `${import.meta.env?.BASE_URL || '/'}thai-address.json`

function squash(text: string): string {
  return String(text || '').replace(/\s+/g, '')
}

const remembered = new Map<string, AddressParts>()

/** ช่องแยกที่ผู้ใช้เลือกล่าสุด — ข้อความเดียวกันได้ค่าเดิม (ไม่ต้องแยกจากข้อความซ้ำ) */
export function rememberAddressParts(text: string, parts: AddressParts): void {
  const key = squash(text)
  if (!key) return
  if (remembered.size > 50) remembered.clear()
  remembered.set(key, parts)
}

/** ข้อมูลแยกช่องของข้อความ (ครบ + ประกอบแล้วตรงทุกตัวอักษร) · ไม่ได้ = null */
export function addressPartsOfText(text: string): AddressParts | null {
  const key = squash(text)
  if (!key) return null
  const hit = remembered.get(key)
  if (hit && isAddressPartsComplete(hit) && squash(composeAddress(hit)) === key) return hit
  const db = loadedThaiAddressDb()
  if (!db) return null
  const parsed = parseThaiAddress(db, text)
  return parsed && isAddressPartsComplete(parsed) && squash(composeAddress(parsed)) === key ? parsed : null
}

/**
 * ที่อยู่พร้อมส่งไหม — โหลดข้อมูลรหัสไปรษณีย์แล้วต้องครบทุกช่อง
 * ถ้าโหลดข้อมูลไม่ได้ (เน็ตมีปัญหา) ยอมรับข้อความที่ไม่ว่าง เพื่อไม่ให้ลูกค้ายืนยันออร์เดอร์ไม่ได้
 */
export function isAddressTextReady(text: string): boolean {
  if (!String(text || '').trim()) return false
  if (!loadedThaiAddressDb()) return true
  return !!addressPartsOfText(text)
}
